import React from 'react';
import { NavigationItem } from 'shared-types';

interface NavigationEditorProps {
    navigation: NavigationItem[];
    onChange: (newNav: NavigationItem[]) => void;
}

const NavigationEditor: React.FC<NavigationEditorProps> = ({ navigation, onChange }) => {

    const handleItemChange = (index: number, field: keyof NavigationItem, value: any) => {
        const newNav = [...navigation];
        // @ts-ignore
        newNav[index][field] = value;
        onChange(newNav);
    };

    const handleAddItem = () => {
        const newItem: NavigationItem = {
            id: `nav_${Date.now()}`,
            label: 'New Link',
            path: '/',
            order: navigation.length + 1,
            visible: true,
        };
        onChange([...navigation, newItem]);
    };
    
    const handleRemoveItem = (index: number) => {
        const newNav = navigation.filter((_, i) => i !== index);
        onChange(newNav);
    };

    return (
        <div className="space-y-4">
            {navigation.map((item, index) => (
                <div key={item.id} className="grid grid-cols-1 md:grid-cols-12 gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-lg border border-slate-200 dark:border-slate-700">
                    <div className="md:col-span-4">
                        <label className="text-xs font-medium text-slate-500">Label</label>
                        <input type="text" value={item.label} onChange={e => handleItemChange(index, 'label', e.target.value)} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1" />
                    </div>
                     <div className="md:col-span-4">
                        <label className="text-xs font-medium text-slate-500">Path</label>
                        <input type="text" value={item.path} onChange={e => handleItemChange(index, 'path', e.target.value)} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1" />
                    </div>
                    <div className="md:col-span-2 flex items-end">
                        <label className="flex items-center gap-2 text-sm cursor-pointer">
                            <input type="checkbox" checked={item.visible} onChange={e => handleItemChange(index, 'visible', e.target.checked)} className="h-4 w-4 rounded text-cyan-600 focus:ring-cyan-500" />
                            Visible
                        </label>
                    </div>
                    <div className="md:col-span-2 flex items-end justify-end">
                         <button onClick={() => handleRemoveItem(index)} className="px-3 py-2 bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300 text-sm font-semibold rounded-md hover:bg-red-200 dark:hover:bg-red-900/60 transition">Remove</button>
                    </div>
                </div>
            ))}
            <button onClick={handleAddItem} className="px-4 py-2 bg-cyan-100 text-cyan-800 dark:bg-cyan-900/40 dark:text-cyan-300 text-sm font-semibold rounded-full hover:bg-cyan-200 dark:hover:bg-cyan-900/60 transition">
                + Add Nav Link
            </button>
        </div>
    );
};

export default NavigationEditor;